
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const SystemSettings = () => {
  const handleSystemRestart = () => {
    toast.info("Systemneustart wurde eingeleitet");
  };

  return (
    <Card className="backdrop-blur-sm bg-white/10 border border-gray-700/30">
      <CardHeader>
        <CardTitle className="text-white">System Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-gray-300">CPU Auslastung</span>
            <div className="bg-gray-700 w-2/3 h-2 rounded-full overflow-hidden">
              <div className="bg-green-500 h-full rounded-full" style={{ width: '23%' }}></div>
            </div>
            <span className="text-sm text-gray-300">23%</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-300">Arbeitsspeicher</span>
            <div className="bg-gray-700 w-2/3 h-2 rounded-full overflow-hidden">
              <div className="bg-yellow-500 h-full rounded-full" style={{ width: '68%' }}></div>
            </div>
            <span className="text-sm text-gray-300">68%</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-300">Festplatte</span>
            <div className="bg-gray-700 w-2/3 h-2 rounded-full overflow-hidden">
              <div className="bg-blue-500 h-full rounded-full" style={{ width: '42%' }}></div>
            </div>
            <span className="text-sm text-gray-300">42%</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-300">Netzwerk</span>
            <div className="bg-gray-700 w-2/3 h-2 rounded-full overflow-hidden">
              <div className="bg-purple-500 h-full rounded-full" style={{ width: '37%' }}></div>
            </div>
            <span className="text-sm text-gray-300">37%</span>
          </div>
        </div>
        
        <div className="mt-6">
          <Button 
            onClick={handleSystemRestart}
            className="bg-[#1d4ed8] hover:bg-[#1e40af] text-white"
          >
            System neustarten
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
